<template>
  <h2 v-if="to" class="section-title__wrapper">
    <a-link :to="to">
      <slot />
    </a-link>
  </h2>
  <h2 v-else class="section-title__wrapper"><slot /></h2>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'

export default {
  name: 'SectionTitle',
  props: {
    to: propValidator([PROP_TYPES.OBJECT, PROP_TYPES.STRING], false)
  }
}
</script>

<style scoped lang="scss">
@import '~assets/scss/global/mixins/figures';
@import '~assets/scss/local/styles/article';

.section-title__wrapper {
  @extend .sidebar-section-title;

  &::after {
    @include delimiter(
      $color: $c--gray-dark-1,
      $thickness: 2px,
      $mt: 8px,
      $mb: 20px
    );
  }
}
</style>
